let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jE3M9")).then(() => parcelRequire('fdj4W'));